// Limited Hair Collections — central source of truth for both the Home
// section and the dedicated /collections/:slug detail pages.
// Each collection has its own brand-aligned palette so the tiles feel distinct
// while still living inside the Homeyoursoul aesthetic.

export const COLLECTIONS = [
  {
    slug: 'blossom-delight',
    emoji: '🌸',
    name: 'Blossom Delight',
    tagline: 'Die Freude an blühender Schönheit',
    style: 'Kawaii',
    colors: ['Rosa', 'Weiß', 'Pastell'],
    designs: ['Herzen', 'Schleifen', 'Kirschblüten'],
    mood: ['Süß', 'Verspielt', 'Romantisch'],
    stylingTip: 'Perfekt zu hellen Sommeroutfits.',
    // Soft pink / cream brand-aligned palette
    palette: { bg: '#FDE6EC', accent: '#E89BAC', text: '#6B3E4A' },
  },
  {
    slug: 'golden-elegance',
    emoji: '✨',
    name: 'Golden Elegance',
    tagline: 'Zeitlose Eleganz mit goldenen Akzenten',
    style: 'Elegant',
    colors: ['Creme', 'Beige', 'Schwarz', 'Gold'],
    designs: ['Perlen', 'Goldakzente', 'Schlichte Eleganz'],
    mood: ['Zeitlos', 'Hochwertig', 'Elegant'],
    stylingTip: 'Edler Akzent zu Business-Looks und Abendgarderobe.',
    palette: { bg: '#F5EDE0', accent: '#C4A04A', text: '#5D4A1F' },
  },
  {
    slug: 'shiny-glam',
    emoji: '💎',
    name: 'Shiny Glam',
    tagline: 'Glanz und Glamour für besondere Momente',
    style: 'Glam',
    colors: ['Silber', 'Schwarz', 'Grau'],
    designs: ['Glitzer', 'Strassoptik', 'Glamouröse Elemente'],
    mood: ['Luxuriös', 'Auffällig', 'Modern'],
    stylingTip: 'Strahlt auf Partys, Hochzeiten und Galas.',
    palette: { bg: '#E8EAEE', accent: '#8B8FA3', text: '#2B2D3A' },
  },
  {
    slug: 'boho-nature',
    emoji: '🌿',
    name: 'Boho Nature',
    tagline: 'Natürliche Leichtigkeit im Boho-Style',
    style: 'Boho',
    colors: ['Braun', 'Olivgrün', 'Terrakotta', 'Creme'],
    designs: ['Blumen', 'Naturtöne', 'Holzoptik'],
    mood: ['Natürlich', 'Entspannt', 'Harmonisch'],
    stylingTip: 'Ideal zu Leinen, Strick und entspannten Sommertagen.',
    palette: { bg: '#EBE4D4', accent: '#8B6F47', text: '#3E2E1A' },
  },
  {
    slug: 'mocha-vintage',
    emoji: '🤎',
    name: 'Mocha Vintage',
    tagline: 'Nostalgischer Charme in warmen Tönen',
    style: 'Vintage',
    colors: ['Bordeaux', 'Rosé', 'Creme', 'Roségold'],
    designs: ['Samt', 'Perlen', 'Retro-Elemente'],
    mood: ['Nostalgisch', 'Romantisch', 'Klassisch'],
    stylingTip: 'Perfekt für romantische Looks im Herbst-Stil.',
    palette: { bg: '#EBD9CF', accent: '#A86A6A', text: '#4A2A2E' },
  },
  {
    slug: 'hot-sunset',
    emoji: '🔥',
    name: 'Hot Sunset',
    tagline: 'Leidenschaftlich. Selbstbewusst. Magnetisch.',
    style: 'Hot Glam',
    colors: ['Rubinrot', 'Bordeaux', 'Schwarz', 'Schwarz-Gold'],
    designs: ['Tüll', 'Satin', 'Samt', 'Rosen', 'Schleifen'],
    mood: ['Leidenschaftlich', 'Selbstbewusst', 'Elegant', 'Magnetisch'],
    stylingTip: 'Statement-Look für Dates und besondere Abende.',
    productNames: ['Ruby Glow', 'Black Desire', 'Red Velvet', 'Scarlet Dream', 'Midnight Rose', 'Rose Noir'],
    palette: { bg: '#3C1F22', accent: '#C04050', text: '#F5EDE4' },
  },
];

// Boxen — placeholder until real products exist
export const COLLECTION_BOXES = [
  {
    slug: 'mini-collection-box',
    emoji: '🎀',
    name: 'Mini Collection Box',
    price: 9.99,
    items: '4 Haargummis · 1 Haarclip · 1 Mini-Extra · 1 Collection Card',
    total: '6 Artikel',
    description: 'Perfekt zum Kennenlernen einer Collection.',
  },
  {
    slug: 'classic-collection-box',
    emoji: '👑',
    name: 'Classic Collection Box',
    price: 14.99,
    items: '5 Haargummis · 1 Haarclip · 3 Mini-Extras (z.B. Spiegel, Kamm, Scrunchie) · 1 Collection Card',
    total: '9 Artikel',
    description: 'Die Hauptbox und unser Bestseller.',
  },
];
